import { css } from '@emotion/react';

import { theme } from '../../theme';

export const confirmationStyles = {
  confirmationPageContainer: css`
    max-width: 1200px;
    padding: 0 ${theme.spacing.lg} ${theme.spacing.lg} ${theme.spacing.lg};
    margin-right: auto;
    margin-left: auto;
    display: block;
  `,
  headerContainer: css`
    margin-top: ${theme.spacing.xxxl};
    margin-bottom: ${theme.spacing.lg};
    display: flex;
    flex-direction: column;
    align-items: center;
    > h1 {
      margin: ${theme.spacing.md};
    }
    @media (max-width: ${theme.breakpoints.tablet}) {
      > p {
        text-align: center;
      }
      > h1 {
        text-align: center;
      }
    }
  `,
  bookingRef: css`
    border-radius: ${theme.borders.radius.sm} ${theme.borders.radius.sm} 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: ${theme.spacing.md};
    background-color: ${theme.colors.background.header};
    color: ${theme.colors.white};
    padding: ${theme.spacing.md};
    > div {
      > p {
        margin: 0px;
        font-size: ${theme.fontSize.lg};
      }
    }
  `,
  flexContainer: css`
    display: flex;
    align-items: center;
  `,
  backgroundContainer: css`
    max-width: 1200px;
    padding: ${theme.spacing.sm};
    background-color: ${theme.colors.gray[1]};
    border-radius: 0 0 ${theme.borders.radius.sm} ${theme.borders.radius.sm};
    margin-right: auto;
    margin-left: auto;
  `,
  flightNumberParagraph: css`
    font-size: ${theme.fontSize.xs};
    margin-top: ${theme.spacing.md};
  `,
};
